import { IsNumber, Max, Min } from 'class-validator';
import { AllergenDto } from './allergen.dto';
import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { ProductCategoryDto } from './productCategory.dto';
import { RecipeDto } from './recipe.dto';
import { ModifierOutOfStockDto } from './modifierOutOfStock.dto';
import { VATRateDto } from './vat-rate.dto';

export class ModifierDto extends BaseDto {
  name: string;
  description: string;
  enabled?: boolean;
  calorieCount: number;
  price: number;
  selected: boolean;
  merchantId?: number;
  brandId?: number;
  brand?: BrandDto;
  sharedSourceName?: string;
  tag: string;
  modifierId?: number;
  isCustomerVisible?: boolean;
  isMultiSelect?: boolean;
  modifierGroupId?: number; // UP-4100 - required for orderItemModifier reorder
  /** UP-38187 - required for reopen closed order. */
  selectedValue?: number; 
  allergens?: AllergenDto[];
  recipes?: RecipeDto[];
  isLoyalty?: boolean;
  modifiersOutOfStock?: ModifierOutOfStockDto[];
  clickedSequence?: number;
  vatRateId?: number;
  vatRate?: VATRateDto;

  @IsNumber()
  @Min(0)
  @Max(2147483647)
  pointsGiven?: number;

  @IsNumber()
  @Min(0)
  @Max(2147483647)
  pointsRequired?: number;

  productCategory: ProductCategoryDto;
  productCategoryLev2?: ProductCategoryDto;

  colorCode?: string;
}
